import { MessageContent } from "@/components/CodeGen/Chat/MessageContent";
import { useInputStore, useMessageStore } from "@/state/stores";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(codegen)/codegen/")({
  component: IndexPage,
});

function IndexPage() {
  const messages = useMessageStore((state) => state.messages);
  const isLoading = useMessageStore((state) => state.isLoading);

  if (messages.length > 0) {
    return (
      <div className="flex flex-col gap-5">
        {messages
          .filter((message) => message.sender === "user")
          .map((message) => (
            <MessageContent
              key={message.id}
              type="ephemeral"
              id="ephemeral-message"
              sender={"user"}
              content={message.content}
              status={message.status}
              isCancelled={false}
              hasUserAttachments={false}
            />
          ))}
      </div>
    );
  }

  if (isLoading) {
    return <EphemeralMessage />;
  }

  return null;
}

function EphemeralMessage() {
  const input = useInputStore((state) => state.message);
  return (
    <div className="flex flex-col gap-5">
      <MessageContent
        type="ephemeral"
        id="ephemeral-message"
        sender="user"
        content={input}
        status="completed"
        isCancelled={false}
        hasUserAttachments={false}
      />
    </div>
  );
}
